import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";

const NAV = [
  { label: "Home", to: "/" },
  { label: "Features", to: "/features" },
  { label: "Download", to: "/download" },
  { label: "FAQ", to: "/faq" },
  { label: "Über uns", to: "/ueber-uns" },
  { label: "Support", to: "/support" },
  { label: "Datenschutz", to: "/datenschutz" },
  { label: "Impressum", to: "/impressum" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const slug = (to) => (to === "/" ? "home" : to.slice(1));
  const isActive = (to) => (to === "/" ? pathname === "/" : pathname.startsWith(to));

  const linkClass = (to) =>
    `whitespace-nowrap rounded-full px-3.5 py-2 text-sm transition-colors ${
      isActive(to) ? "bg-white/10 text-white" : "text-white/60 hover:text-white"
    }`;

  return (
    <motion.header
      data-testid="site-header"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed left-0 right-0 top-0 z-50 transition-colors duration-300 ${
        scrolled ? "glass" : "bg-transparent max-lg:glass"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 lg:px-8">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2.5">
          <img
            src="/logo.png"
            alt="FestivalPlan Logo"
            className="h-10 w-10 rounded-xl object-cover"
          />
          <span className="font-display text-lg font-semibold tracking-tight text-white">
            FestivalPlan
          </span>
        </Link>

        <nav data-testid="main-nav" className="hidden items-center gap-1 lg:flex">
          {NAV.map((item) => (
            <Link
              key={item.label}
              to={item.to}
              data-testid={`nav-${slug(item.to)}`}
              aria-current={isActive(item.to) ? "page" : undefined}
              className={linkClass(item.to)}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <Link
          to="/download"
          data-testid="header-cta-btn"
          className="btn-primary px-5 py-2.5 text-sm font-medium"
        >
          App laden
        </Link>
      </div>

      <nav
        data-testid="mobile-nav"
        aria-label="Hauptnavigation"
        className="no-scrollbar flex gap-1 overflow-x-auto border-t border-white/5 px-5 py-2 lg:hidden"
      >
        {NAV.map((item) => (
          <Link
            key={item.label}
            to={item.to}
            data-testid={`mobile-nav-${slug(item.to)}`}
            aria-current={isActive(item.to) ? "page" : undefined}
            className={`${linkClass(item.to)} min-h-[40px] inline-flex items-center`}
          >
            {item.label}
          </Link>
        ))}
      </nav>
    </motion.header>
  );
}
